"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var dateFormats = {
  LITTLE_ENDIAN: 'little_endian',
  MIDDLE_ENDIAN: 'middle_endian',
  BIG_ENDIAN: 'big_endian'
};
var _default = dateFormats;
exports["default"] = _default;